.Ember.TitleScreen {
  width: 100%;
  height: 100%;
  position: relative;
  background-size: auto 100%;
  background-position: center right;
  background-image: url("@fae/source/assets/images/ember-tactics/screens/title/titlescreen.lowres.png");
}
.Ember.TitleScreen .Contents {
  top: 0em;
  right: 0em;
  bottom: 0em;
  width: 55%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-bottom: 1.5em;
}
.Ember.TitleScreen .Contents .Title {
  height: 1.5em;
  margin-bottom: 0.3em;
}
.Ember.TitleScreen .Contents .Buttons {
  padding-left: 0.15em;
}
.Ember.TitleScreen .Contents .Buttons .Button {
  font-size: 0.4em;
  color: #feebcc;
}
.Ember.TitleScreen .Contents .Buttons .Button:hover {
  opacity: 1;
  color: #ff8232;
  cursor: pointer;
}
